import React, { useState, useEffect, useRef } from "react";
import ProductName from "./ProductName";
import ProductAbout from "./ProductAbout";
import ProductBenefits from "./ProductBenifits";
import ProductDescription from "./ProductDescription";
import ProductIngredients from "./ProductIngredients";
import ProductHowToUse from "./ProductHowToUse";
import ProductDosage from "./ProductDosage";
import DraggableSection from "./DragbleSection";
import "./ProductDetails.css";
import AddSection from "./AddSection";
import { DragDropContext, Droppable } from "@hello-pangea/dnd";
import styles from "./../../pages/Preview/PreviewProductDescription.module.css";
import Carousel from "react-bootstrap/Carousel";
import { Accordion } from "react-bootstrap";
import { useProductContext } from "../Context/ProductContext";
import { LiaCommentDots } from "react-icons/lia";
import CommentBox from "../Common/CommentBox";
import { commentService } from "../../services/commentService";
import { generateProductDescriptionStream, hideSection, unhideSection, fetchHiddenSections } from "../../utils/Product";
import Loader from "../Common/Loader";
import { useAuth } from "../Context/authContext";
import ProductBenefit01 from "./ModalComponents/ProductBenefit01";
import ProductBenefit02 from "./ModalComponents/ProductBenefit02";
import ProductBenefit03 from "./ModalComponents/ProductBenifit03";
import OneColumnSection from "./ModalComponents/OneColumnSection";
import MultiColumnSection from "./ModalComponents/MultiColumnSection";
import CardLayoutSection from "./ModalComponents/CardLayoutSection";
import MetafieldRenderer from "../Common/MetafieldRenderer";
import MetafieldSection from "./MetafieldSection";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import ConfirmHideSectionModal from "./ConfirmHideSectionModal";
import { toast } from "react-toastify";
import { EyeOff } from "lucide-react";
import BaseButton from "../Common/BaseButton";
const ProductDetailsContainer = ({
  productname,
  productabout,
  productdescription,
  benifitss,
  handleProductRegenerate,
  ingredients,
  howToUse,
  dosage,
  heroImage,
  productImages,
  language,
  locationFocus,
  initialSku,
  keywords,
  agentId,
  sessionId,
  isStreaming,
  onSectionUpdate,
  accumulatedStreamData,
  furtherDetails,
  regeneratingSection,
  onSave,
  metafields,
  handleManualEdit,
  productId,
  collections,
  variants,
  productData,
  onGetCurrentSectionOrder
}) => {
  const { user: currentUser } = useAuth();
  const [sections, setSections] = useState([]);
  const [extraSections, setExtraSections] = useState([]);
  const [hiddenSections, setHiddenSections] = useState([]); // Track hidden section IDs locally
  const [hiddenSectionsData, setHiddenSectionsData] = useState([]); // Store hidden sections from API
  const [sectionOrder, setSectionOrder] = useState([]);
  const [isSectionOrderInitialized, setIsSectionOrderInitialized] = useState(false);
  const [error, setError] = useState(null);
  const { previewMode, updateProductData } = useProductContext();
  const [showHideModal, setShowHideModal] = useState(false);
  const [sectionToHide, setSectionToHide] = useState(null);
  const [sectionTitleToHide, setSectionTitleToHide] = useState("");
  const updatedSections = React.useMemo(
    () => [
      ...(productname ? [{
        id: "name",
        Component: (props) => (
          <ProductName
            {...props}
            productname={productname}
            handleProductRegenerate={handleProductRegenerate}
            previewMode={previewMode}
            furtherDetails={furtherDetails}
            loading={regeneratingSection.includes("title")}
            handleManualEdit={handleManualEdit}
            onHide={handleHideSection}
            sectionId="name"
            sectionTitle="Product Name"
          />
        ),
      }] : []),
      ...(productabout ? [{
        id: "about",
        Component: (props) => (
          <ProductAbout
            {...props}
            productabout={productabout}
            handleProductRegenerate={handleProductRegenerate}
            previewMode={previewMode}
            loading={regeneratingSection.includes("teaser")}
            handleManualEdit={handleManualEdit}
            onHide={handleHideSection}
            sectionId="about"
            sectionTitle="Product About"
          />
        ),
      }] : []),
      ...(benifitss && (Array.isArray(benifitss) ? benifitss.length > 0 : Object.keys(benifitss || {}).length > 0) ? [{
        id: "benefits",
        Component: (props) => (
          <ProductBenefits
            {...props}
            initialBenefits={benifitss}
            handleProductRegenerate={handleProductRegenerate}
            previewMode={previewMode}
            loading={regeneratingSection.includes("highlights")}
            handleManualEdit={handleManualEdit}
            onHide={handleHideSection}
            sectionId="benefits"
            sectionTitle="Product Benefits"
          />
        ),
      }] : []),
      ...(productdescription ? [{
        id: "description",
        Component: (props) => (
          <ProductDescription
            {...props}
            productdescription={productdescription}
            handleProductRegenerate={handleProductRegenerate}
            previewMode={previewMode}
            loading={regeneratingSection.includes("description")}
            handleManualEdit={handleManualEdit}
            onHide={handleHideSection}
            sectionId="description"
            sectionTitle="Product Description"
          />
        ),
      }] : []),
      ...(ingredients && (typeof ingredients === 'string' ? ingredients.trim() : Object.keys(ingredients || {}).length > 0) ? [{
        id: "ingredients",
        Component: (props) => (
          <ProductIngredients
            {...props}
            ingredient={ingredients}
            handleProductRegenerate={handleProductRegenerate}
            previewMode={previewMode}
            loading={regeneratingSection.includes("ingredients")}
            handleManualEdit={handleManualEdit}
            initialSku={initialSku}
            keywords={keywords}
            onHide={handleHideSection}
            sectionId="ingredients"
            sectionTitle="Ingredients"
          />
        ),
      }] : []),
      // Conditionally show either howToUse or dosage based on available data
      ...(howToUse && !dosage
        ? [
            {
              id: "howToUse",
              Component: (props) => (
                <ProductHowToUse
                  {...props}
                  howtoUse={howToUse}
                  handleProductRegenerate={handleProductRegenerate}
                  previewMode={previewMode}
                  loading={regeneratingSection.includes("how_to_use")}
                  handleManualEdit={handleManualEdit}
                  initialSku={initialSku}
                  keywords={keywords}
                  onHide={handleHideSection}
                  sectionId="howToUse"
                  sectionTitle="How To Use"
                />
              ),
            },
          ]
        : []),
      ...(dosage
        ? [
            {
              id: "dosage",
              Component: (props) => (
                <ProductDosage
                  {...props}
                  dosage={dosage}
                  handleProductRegenerate={handleProductRegenerate}
                  previewMode={previewMode}
                  loading={regeneratingSection.includes("dosage")}
                  handleManualEdit={handleManualEdit}
                  initialSku={initialSku}
                  keywords={keywords}
                  onHide={handleHideSection}
                  sectionId="dosage"
                  sectionTitle="Dosage"
                />
              ),
            },
          ]
        : []),
      // Add each metafield as a separate draggable section
      // Separate regular metafields from collections variant arrays
      ...(Array.isArray(metafields) && metafields.length > 0 ? 
        metafields
          .filter((metafield) => {
            const isCollectionsVariant = 
              (metafield.type && (
                metafield.type.includes('list.collection') || 
                metafield.type.includes('list.variant') ||
                metafield.type.includes('collection') ||
                metafield.type.includes('variant')
              )) ||
              (metafield.key && (
                metafield.key.toLowerCase().includes('collections') ||
                metafield.key.toLowerCase().includes('variant')
              ));
            return !isCollectionsVariant;
          })
          .map((metafield, index) => {
            const sectionId = `metafield--${metafield.key}`;
            const formatKey = (key) => {
              if (!key) return '';
              return key.replace(/[-_]/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
            };
            const sectionTitle = formatKey(metafield.key) || `Metafield ${index + 1}`;
            return {
              id: sectionId,
              Component: (props) => (
                <MetafieldSection
                  {...props}
                  metafield={metafield}
                  handleProductRegenerate={handleProductRegenerate}
                  previewMode={previewMode}
                  loading={regeneratingSection.includes(sectionId)}
                  handleManualEdit={handleManualEdit}
                  metafields={metafields}
                  setMetafields={(newMetafields) => handleManualEdit("metafields", newMetafields)}
                  onHide={handleHideSection}
                  sectionId={sectionId}
                  sectionTitle={sectionTitle}
                />
              ),
            };
          })
          .concat(
            metafields
              .filter((metafield) => {
                const isCollectionsVariant = 
                  (metafield.type && (
                    metafield.type.includes('list.collection') || 
                    metafield.type.includes('list.variant') ||
                    metafield.type.includes('collection') ||
                    metafield.type.includes('variant')
                  )) ||
                  (metafield.key && (
                    metafield.key.toLowerCase().includes('collections') ||
                    metafield.key.toLowerCase().includes('variant')
                  ));
                return isCollectionsVariant;
              })
              .map((metafield, index) => {
                const sectionId = `collections-variant-${metafield.namespace}-${metafield.key}-${index}`;
                const formatKey = (key) => {
                  if (!key) return '';
                  return key.replace(/[-_]/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
                };
                const sectionTitle = formatKey(metafield.key) || `Collections/Variant ${index + 1}`;
                return {
                  id: sectionId,
                  Component: (props) => (
                    <MetafieldSection
                      {...props}
                      metafield={metafield}
                      handleProductRegenerate={handleProductRegenerate}
                      previewMode={previewMode}
                      loading={regeneratingSection.includes(sectionId)}
                      handleManualEdit={handleManualEdit}
                      metafields={metafields}
                      setMetafields={(newMetafields) => handleManualEdit("metafields", newMetafields)}
                      onHide={handleHideSection}
                      sectionId={sectionId}
                      sectionTitle={sectionTitle}
                    />
                  ),
                };
              })
          ) :
        // Show skeleton loaders only when metafields haven't been loaded yet (undefined/null)
        // If metafields is an empty array, API has been fetched, so don't show skeletons
        !Array.isArray(metafields) ? 
        Array.from({ length: 3 }, (_, index) => ({
          id: `metafield-skeleton-${index}`,
          Component: (props) => (
            <div className="product-section">
              <div className="section-header">
                <div className="section-title">
                  <Skeleton height={20} width={150} />
                </div>
              </div>
              <div>
                <Skeleton height={12} width="90%" style={{ marginBottom: 5 }} count={5} />
              </div>
            </div>
          ),
        })) : []
      ),
      // Collections section removed - not shown on edit and preview screens
      // ...(collections && Array.isArray(collections) && collections.length > 0 ? [{
      //   id: "collections",
      //   Component: (props) => {
      //     const isPreview = props?.previewMode;
      //     return (
      //       <div className={isPreview ? styles.previewSection : "product-section"}>
      //         {!isPreview && (
      //           <div className="section-header">
      //             <div className="section-title">Collections</div>
      //           </div>
      //         )}
      //         {isPreview && <h2>Collections:</h2>}
      //         <div className={isPreview ? "" : "description-tabs"}>
      //           <div className="collections-container" style={{ padding: '15px' }}>
      //             {collections.map((collection, index) => (
      //               <div key={collection.id || index} style={{
      //                 marginBottom: '15px',
      //                 padding: '12px',
      //                 background: '#f8f9fa',
      //                 borderRadius: '5px',
      //                 border: '1px solid #dee2e6'
      //               }}>
      //                 <div style={{ fontWeight: 600, color: '#495057', marginBottom: '5px' }}>
      //                   {collection.title || 'Untitled Collection'}
      //                 </div>
      //                 {collection.handle && (
      //                   <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '5px' }}>
      //                     Handle: {collection.handle}
      //                   </div>
      //                 )}
      //                 {collection.collection_url && (
      //                   <div style={{ fontSize: '14px', color: '#6b7280' }}>
      //                     <a href={collection.collection_url} target="_blank" rel="noopener noreferrer" style={{ color: '#007bff' }}>
      //                       {collection.collection_url}
      //                     </a>
      //                   </div>
      //                 )}
      //                 {collection.collection_type && (
      //                   <div style={{ fontSize: '12px', color: '#868e96', marginTop: '5px' }}>
      //                     Type: {collection.collection_type}
      //                   </div>
      //                 )}
      //               </div>
      //             ))}
      //           </div>
      //         </div>
      //       </div>
      //     );
      //   },
      // }] : []),
      // Add variants section if available
      ...(variants && Array.isArray(variants) && variants.length > 0 ? [{
        id: "variants",
        Component: (props) => {
          const isPreview = props?.previewMode;
          return (
            <div className={isPreview ? styles.previewSection : "product-section"}>
              {!isPreview && (
                <div className="section-header">
                  <div className="section-title">Variants</div>
                </div>
              )}
              {isPreview && <h2>Variants:</h2>}
              <div className={isPreview ? "" : "description-tabs"}>
                <div className="variants-container" style={{ padding: '15px' }}>
                  {variants.map((variant, index) => (
                    <div key={variant.id || index} style={{
                      marginBottom: '15px',
                      padding: '12px',
                      background: '#f8f9fa',
                      borderRadius: '5px',
                      border: '1px solid #dee2e6'
                    }}>
                      <div style={{ fontWeight: 600, color: '#495057', marginBottom: '5px' }}>
                        {variant.title || 'Untitled Variant'}
                      </div>
                      <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '5px' }}>
                        <div>Price: {variant.price || 'N/A'}</div>
                        {variant.compare_at_price && (
                          <div>Compare at Price: {variant.compare_at_price}</div>
                        )}
                        {variant.sku && (
                          <div>SKU: {variant.sku}</div>
                        )}
                        {variant.barcode && (
                          <div>Barcode: {variant.barcode}</div>
                        )}
                        {variant.inventory_quantity !== undefined && (
                          <div>Inventory: {variant.inventory_quantity}</div>
                        )}
                        {variant.weight && (
                          <div>Weight: {variant.weight} {variant.weight_unit || 'g'}</div>
                        )}
                      </div>
                      {(variant.option1 || variant.option2 || variant.option3) && (
                        <div style={{ fontSize: '12px', color: '#868e96', marginTop: '5px' }}>
                          Options: {[variant.option1, variant.option2, variant.option3].filter(Boolean).join(', ')}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          );
        },
      }] : []),
    ],
    [
      productname,
      productabout,
      productdescription,
      benifitss,
      ingredients,
      howToUse,
      dosage,
      metafields,
      variants,
      handleProductRegenerate,
      previewMode,
      regeneratingSection,
      onSave,
      productData,
    ]
  );
  
 
  useEffect(() => {
    if (accumulatedStreamData?.sectionOrder && Array.isArray(accumulatedStreamData.sectionOrder)) {
     
      if (!isSectionOrderInitialized) {
        setSectionOrder(accumulatedStreamData.sectionOrder);
        setIsSectionOrderInitialized(true);
      } else {
        // Update when sectionOrder changes (e.g., when applying a template)
        // Only update if it's actually different to avoid unnecessary re-renders
        setSectionOrder(prev => {
          const newOrder = accumulatedStreamData.sectionOrder;
          if (JSON.stringify(prev) !== JSON.stringify(newOrder)) {
            return newOrder;
          }
          return prev;
        });
      }
    }
  }, [accumulatedStreamData?.sectionOrder, isSectionOrderInitialized]);

  useEffect(() => {
    // Filter out hidden sections
    const visibleCoreSections = updatedSections.filter(
      (section) => !hiddenSections.includes(section.id)
    );
    const visibleExtraSections = extraSections.filter(
      (section) => !hiddenSections.includes(section.id)
    );

    const allVisibleSections = [...visibleCoreSections, ...visibleExtraSections];
    
    if (sectionOrder.length > 0 && isSectionOrderInitialized) {
      const sectionMap = new Map(allVisibleSections.map(s => [s.id, s]));
      const cleanedOrder = sectionOrder.filter(sectionId => 
        sectionMap.has(sectionId) && !hiddenSections.includes(sectionId)
      );
      
      if (cleanedOrder.length !== sectionOrder.length) {
        setSectionOrder(cleanedOrder);
        if (onSectionUpdate) {
          onSectionUpdate("order", { sectionOrder: cleanedOrder });
        }
      }
    }
    
    if (sectionOrder.length > 0) {
      const sectionMap = new Map(allVisibleSections.map(s => [s.id, s]));
      const orderedSections = [];
      const processedIds = new Set();
      
      sectionOrder.forEach(sectionId => {
        if (sectionMap.has(sectionId) && !hiddenSections.includes(sectionId)) {
          orderedSections.push(sectionMap.get(sectionId));
          processedIds.add(sectionId);
        }
      });
      
      allVisibleSections.forEach(section => {
        if (!processedIds.has(section.id)) {
          orderedSections.push(section);
        }
      });
      
      setSections(orderedSections);
    } else {
      setSections(allVisibleSections);
    }
  }, [
    productname,
    productabout,
    productdescription,
    benifitss,
    ingredients,
    howToUse,
    dosage,
    handleProductRegenerate,
    previewMode,
    extraSections,
    hiddenSections,
    updatedSections,
    sectionOrder,
    isSectionOrderInitialized,
    onSectionUpdate,
  ]);

  // Expose current section order to parent component
  // This includes the actual rendered order of all visible sections
  const prevOrderRef = useRef(null);
  useEffect(() => {
    if (onGetCurrentSectionOrder) {
      // Get the actual rendered section order (sections array reflects the current display order)
      const actualOrder = sections.map(section => section.id);
      const orderToSend = actualOrder.length > 0 ? actualOrder : (sectionOrder.length > 0 ? sectionOrder : null);
      
      // Only call callback if order actually changed
      if (orderToSend) {
        const orderKey = JSON.stringify(orderToSend);
        if (orderKey !== prevOrderRef.current) {
          prevOrderRef.current = orderKey;
          onGetCurrentSectionOrder(orderToSend);
        }
      }
    }
  });

  // Initialize extraSections with section-based benefits from accumulatedStreamData
  useEffect(() => {
    if (
      accumulatedStreamData &&
      Object.keys(accumulatedStreamData).length > 0
    ) {
      // Clear existing layout sections to prevent duplicates
      setExtraSections((prev) => prev.filter(section => !section.id.includes("layout_") || !section.id.includes("-loaded-from-db")));
      const sectionsToCreate = [];

      // Check for FAQ
      if (
        accumulatedStreamData.faq &&
        Array.isArray(accumulatedStreamData.faq) &&
        accumulatedStreamData.faq.length > 0
      ) {
        const FAQComponent = React.lazy(() =>
          import("./ModalComponents/Faq.jsx")
        );
        sectionsToCreate.push({
          id: "faq-loaded-from-db",
          Component: (props) => (
            <React.Suspense fallback={<div>Loading FAQ...</div>}>
              <FAQComponent
                {...props}
                previewMode={previewMode}
                generatedContent={accumulatedStreamData.faq}
                loading={false}
                isNewSection={false}
                language={language}
                locationFocus={locationFocus}
                keywords={keywords}
                setError={setError}
              />
            </React.Suspense>
          ),
          title: "Frequently asked questions",
          generatedContent: accumulatedStreamData.faq,
          loading: false,
          isLoadedFromDB: true,
        });
      }

      // Check for highlights (benefits)
      if (
        accumulatedStreamData.highlights &&
        Array.isArray(accumulatedStreamData.highlights) &&
        accumulatedStreamData.highlights.length > 0
      ) {
        // sectionsToCreate.push({
        //   id: 'highlights-loaded-from-db',
        //   Component: (props) => (
        //     <ProductBenefit01
        //       {...props}
        //       previewMode={previewMode}
        //       initialData={accumulatedStreamData.highlights}
        //       isLoadedFromDB={true}
        //     />
        //   ),
        //   title: 'Product Benefits',
        //   generatedContent: accumulatedStreamData.highlights,
        //   loading: false,
        //   isLoadedFromDB: true,
        // });
      } else {
      }

      // Check for benefit, benefits03, benefits04 sections (these are the API section names)
      ["benefit", "benefits03", "benefits04"].forEach((benefitKey, index) => {
        if (
          accumulatedStreamData[benefitKey] &&
          typeof accumulatedStreamData[benefitKey] === "object" &&
          accumulatedStreamData[benefitKey].benefits &&
          Array.isArray(accumulatedStreamData[benefitKey].benefits) &&
          accumulatedStreamData[benefitKey].benefits.length > 0
        ) {
          // Choose the appropriate component based on benefit type
          let BenefitComponent;
          if (benefitKey === "benefit") {
            BenefitComponent = ProductBenefit01;
          } else if (benefitKey === "benefits03") {
            BenefitComponent = ProductBenefit02;
          } else if (benefitKey === "benefits04") {
            BenefitComponent = ProductBenefit03;
          }

          sectionsToCreate.push({
            id: `${benefitKey}-loaded-from-db`,
            Component: (props) => (
              <BenefitComponent
                {...props}
                previewMode={previewMode}
                initialData={accumulatedStreamData[benefitKey]}
                isLoadedFromDB={true}
                language={language}
                locationFocus={locationFocus}
                setError={setError}
              />
            ),
            title:
              accumulatedStreamData[benefitKey].headline ||
              `Product Benefits ${index + 1}`,
            generatedContent: accumulatedStreamData[benefitKey],
            loading: false,
            isLoadedFromDB: true,
          });
        } else {
        }
      });

      // Check for detailed_ingredients section
      if (
        accumulatedStreamData.detailed_ingredients &&
        Array.isArray(accumulatedStreamData.detailed_ingredients) &&
        accumulatedStreamData.detailed_ingredients.length > 0
      ) {
        const IngredientsComponent = React.lazy(() =>
          import("./ModalComponents/Ingredients")
        );
        sectionsToCreate.push({
          id: "detailed_ingredients-loaded-from-db",
          Component: (props) => (
            <React.Suspense fallback={<div>Loading Ingredients...</div>}>
              <IngredientsComponent
                {...props}
                previewMode={previewMode}
                generatedContent={accumulatedStreamData.detailed_ingredients}
                loading={false}
                isNewSection={false}
                language={language}
                locationFocus={locationFocus}
                setError={setError}
              />
            </React.Suspense>
          ),
          title: "Detailed Ingredients",
          generatedContent: accumulatedStreamData.detailed_ingredients,
          loading: false,
          isLoadedFromDB: true,
        });
      }

      // Handle all layout types - both standard and custom names
      const getLayoutSections = (data) => {
        const layoutSections = [];
        Object.keys(data).forEach((key) => {
          if (key.startsWith("layout_one_column")) {
            layoutSections.push({
              key,
              data: data[key],
              type: "one_column",
              Component: OneColumnSection,
            });
          } else if (key.startsWith("layout_two_columns")) {
            layoutSections.push({
              key,
              data: data[key],
              type: "two_columns",
              Component: MultiColumnSection,
            });
          } else if (key.startsWith("layout_three_columns")) {
            layoutSections.push({
              key,
              data: data[key],
              type: "three_columns",
              Component: MultiColumnSection,
            });
          } else if (key.startsWith("layout_four_columns")) {
            layoutSections.push({
              key,
              data: data[key],
              type: "four_columns",
              Component: MultiColumnSection,
            });
          } else if (key.startsWith("layout_five_columns")) {
            layoutSections.push({
              key,
              data: data[key],
              type: "five_columns",
              Component: MultiColumnSection,
            });
          } else if (key.startsWith("layout_six_columns")) {
            layoutSections.push({
              key,
              data: data[key],
              type: "six_columns",
              Component: MultiColumnSection,
            });
          } else if (key.startsWith("layout_card")) {
            layoutSections.push({
              key,
              data: data[key],
              type: "card",
              Component: CardLayoutSection,
            });
          }
        });
        return layoutSections;
      };
      const layoutSections = getLayoutSections(accumulatedStreamData);
      layoutSections.forEach(({ key, data, type, Component }) => {
        const sectionTitle = data.title || key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
        if (
          data &&
          !isDuplicateLayoutSection(extraSections, type, sectionTitle)
        ) {
          sectionsToCreate.push({
            id: `${key}-loaded-from-db`,
            Component: (props) => (
              <Component
                {...props}
                previewMode={previewMode}
                generatedContent={data}
                handleProductRegenerate={handleProductRegenerate}
                agentId={agentId}
                sessionId={sessionId}
                initialSku={initialSku}
                keywords={keywords}
                language={language}
                locationFocus={locationFocus}
                furtherDetails={furtherDetails}
              />
            ),
            title: sectionTitle,
            generatedContent: data,
            loading: false,
            isLoadedFromDB: true,
            layoutType: type, // Add layoutType for duplicate checking
          });
        }
      });

      // Only update if we have new sections to add
      if (sectionsToCreate.length > 0) {
        setExtraSections((prev) => {
          // More robust duplicate checking by type rather than just ID
          const existingSectionTypes = prev.map((s) => {
            // Extract type from ID patterns like "faq-loaded-from-db", "benefit-1234567", etc.
            if (s.id.includes("faq")) return "faq";
            if (s.id.includes("highlights")) return "highlights";
            if (s.id.includes("benefit-")) return "benefit";
            if (s.id.includes("benefits03")) return "benefits03";
            if (s.id.includes("benefits04")) return "benefits04";
            if (s.id.includes("detailed_ingredients"))
              return "detailed_ingredients";
            // Handle custom layout section names by extracting the base layout type
            if (s.id.includes("layout_one_column"))
              return s.id.split("-loaded-from-db")[0];
            if (s.id.includes("layout_two_columns"))
              return s.id.split("-loaded-from-db")[0];
            if (s.id.includes("layout_three_columns"))
              return s.id.split("-loaded-from-db")[0];
            if (s.id.includes("layout_four_columns"))
              return s.id.split("-loaded-from-db")[0];
            if (s.id.includes("layout_five_columns"))
              return s.id.split("-loaded-from-db")[0];
            if (s.id.includes("layout_six_columns"))
              return s.id.split("-loaded-from-db")[0];
            if (s.id.includes("layout_card"))
              return s.id.split("-loaded-from-db")[0];
            return s.id.split("-")[0]; // fallback to first part of ID
          });

          const newSections = sectionsToCreate.filter((s) => {
            let sectionType;
            if (s.id.includes("faq")) sectionType = "faq";
            else if (s.id.includes("highlights")) sectionType = "highlights";
            else if (s.id.includes("benefit-")) sectionType = "benefit";
            else if (s.id.includes("benefits03")) sectionType = "benefits03";
            else if (s.id.includes("benefits04")) sectionType = "benefits04";
            else if (s.id.includes("detailed_ingredients"))
              sectionType = "detailed_ingredients";
            // For layout sections, use the layoutType from the section object instead of the key
            else if (s.id.includes("layout_")) {
              sectionType = s.layoutType || s.id.split("-loaded-from-db")[0];
            }
            else sectionType = s.id.split("-")[0];

            // For layout sections, also check by title to prevent duplicates
            if (s.id.includes("layout_")) {
              const isDuplicate = prev.some(existingSection => 
                existingSection.id.includes("layout_") && 
                existingSection.title?.toLowerCase() === s.title?.toLowerCase()
              );
              return !isDuplicate;
            }

            return !existingSectionTypes.includes(sectionType);
          });

          if (newSections.length > 0) {
            return [...prev, ...newSections];
          } else {
            return prev;
          }
        });
      } else {
      }
    } else {
    }
  }, [
    accumulatedStreamData,
    previewMode,
    agentId,
    furtherDetails,
    handleProductRegenerate,
    initialSku,
    keywords,
    language,
    locationFocus,
    sessionId,
  ]);

  const handleAddNewSection = async (selectedSection) => {
    // Check if it's a layout-based section
    if (selectedSection.type === "layout_section") {
      const layoutType = selectedSection.layoutType;

      // Generate unique section ID and key based on title
      const sectionTitle =
        selectedSection.title ||
        `${layoutType
          .replace(/_/g, " ")
          .replace(/\b\w/g, (l) => l.toUpperCase())} Section`;

      // Create unique ID for the UI section
      const timestamp = Date.now();
      const sanitizedTitle = sectionTitle
        .replace(/[^a-zA-Z0-9\s]/g, "") // Remove special characters except spaces
        .replace(/\s+/g, "_"); // Replace spaces with underscores

      const uniqueId = Math.random().toString(36).substr(2, 9); // Short random string
      const sectionId = `layout_${layoutType}_${uniqueId}`;
      const newSection = {
        id: sectionId,
        title: sectionTitle,
        Component: (props) => (
          <div className="product-section">
            <div className="section-header">
              <div className="section-title">{sectionTitle}</div>
            </div>
            <div className="section-content">
              {/* Render the layout-based component */}
              {selectedSection.component()}
            </div>
          </div>
        ),
        generatedContent: selectedSection.content,
        loading: false,
        isNewSection: true,
        layoutType: layoutType,
      };

      if (isDuplicateLayoutSection(extraSections, layoutType, sectionTitle)) {
        return; // Already exists, don't add again
      }

      setExtraSections((prev) => [...prev, newSection]);
      
      setSectionOrder((prev) => {
        const newOrder = [...prev, newSection.id];
        if (onSectionUpdate) {
          onSectionUpdate("order", { sectionOrder: newOrder });
        }
        return newOrder;
      });
      if (onSectionUpdate) {
        // Generate unique key by combining layout type with sanitized title
        const uniqueKey = `layout_${layoutType}_${sanitizedTitle}`;

        onSectionUpdate("add", {
          type: uniqueKey,
          generatedContent: {
            title: sectionTitle,
            content: selectedSection.content,
            layoutType: layoutType,
          },
        });
      }

      return;
    }

    // Check if it's a custom section (legacy support)
    if (selectedSection.type === "custom_section") {
      const newSectionId = `custom_section-${Date.now()}`;
      setExtraSections((prev) => [
        ...prev,
        {
          id: newSectionId,
          title: selectedSection.title || "Custom Section",
          Component: (props) => (
            <div className="product-section">
              <div className="section-header">
                <div className="section-title">
                  {selectedSection.title || "Custom Section"}
                </div>
              </div>
              <div className="section-content">
                {/* Render the generated content in your section format */}
                <div className="description-tabs">
                  <div
                    className="productDescription"
                    style={{
                      whiteSpace: "pre-wrap",
                      wordWrap: "break-word",
                      lineHeight: "1.6",
                    }}
                  >
                    {typeof selectedSection.generatedContent === "string"
                      ? selectedSection.generatedContent
                      : JSON.stringify(
                          selectedSection.generatedContent,
                          null,
                          2
                        )}
                  </div>
                </div>
              </div>
            </div>
          ),
          generatedContent: selectedSection.generatedContent,
          loading: false,
          isNewSection: true,
        },
      ]);
      
      setSectionOrder((prev) => {
        const newOrder = [...prev, newSectionId];
        if (onSectionUpdate) {
          onSectionUpdate("order", { sectionOrder: newOrder });
        }
        return newOrder;
      });
      if (onSectionUpdate) {
        // Create a unique key for custom sections to avoid overwriting
        const sectionTitle = selectedSection.title || "Custom Section";
        const sanitizedTitle = sectionTitle
          .replace(/[^a-zA-Z0-9\s]/g, "") // Remove special characters except spaces
          .replace(/\s+/g, "_"); // Replace spaces with underscores
        const timestamp = Date.now();
        const uniqueKey = `custom_section_${sanitizedTitle}_${timestamp}`;

        onSectionUpdate("add", {
          type: uniqueKey,
          generatedContent: selectedSection.generatedContent,
        });
      }

      return;
    }

    // Add a guard to prevent multiple calls for the same section type within a short time
    const now = Date.now();
    const recentSectionKey = `${selectedSection.type}-recent`;
    if (window[recentSectionKey] && now - window[recentSectionKey] < 2000) {
      return;
    }
    window[recentSectionKey] = now;

    // Check if this exact section type already exists (allow multiple benefit types)
    const existingSection = extraSections.find((section) => {
      // For benefits, check for exact type match (benefit vs benefits03 vs benefits04)
      if (
        selectedSection.type === "benefit" ||
        selectedSection.type === "benefits03" ||
        selectedSection.type === "benefits04"
      ) {
        // Check if this exact benefit type already exists
        return (
          section.id.includes(`${selectedSection.type}-`) ||
          section.id.endsWith(`-${selectedSection.type}`) ||
          section.id === `${selectedSection.type}-loaded-from-db`
        );
      }

      // For non-benefit sections, check if section ID contains the type (original logic)
      if (section.id.includes(selectedSection.type)) {
        return true;
      }
      // Check if it's a loaded section with same type
      if (section.isLoadedFromDB && section.id.includes(selectedSection.type)) {
        return true;
      }
      // Check if section ID starts with the type followed by dash
      if (section.id.startsWith(`${selectedSection.type}-`)) {
        return true;
      }
      return false;
    });

    if (existingSection) {
      return;
    }

    // Show loader or placeholder while generating
    const newSectionId = `${selectedSection.type}-${Date.now()}`;
    const newSection = {
      id: newSectionId,
      Component: (props) => {
        // Pass the generatedContent and loading props to the component
        const ComponentToRender = selectedSection.component;
        const currentSection = extraSections.find((s) => s.id === newSectionId);
        return (
          <ComponentToRender
            {...props}
            previewMode={previewMode}
            isNewSection={true} // Mark this as a new section from Add Section flow
            agentId={agentId}
            sessionId={sessionId}
            keywords={keywords}
            language={language}
            locationFocus={locationFocus}
            generatedContent={currentSection?.generatedContent}
            handleProductRegenerate={handleProductRegenerate}
            initialSku={initialSku}
            furtherDetails={furtherDetails}
            setError={setError}
          />
        );
      },
      title: selectedSection.title,
      generatedContent: undefined, // will be filled after API call - undefined means "waiting for data"
      loading: true,
      isNewSection: true, // Mark this section as new
    };
    setExtraSections((prev) => [...prev, newSection]);
    
    setSectionOrder((prev) => {
      const newOrder = [...prev, newSectionId];
      if (onSectionUpdate) {
        onSectionUpdate("order", { sectionOrder: newOrder });
      }
      return newOrder;
    });

    // Call API to generate content for this section
    const languageValue =
      typeof language !== "undefined" && language?.label
        ? language.label
        : language || "";
    const locationValue =
      typeof locationFocus !== "undefined" && locationFocus?.label
        ? locationFocus.label
        : locationFocus || "";

    try {
      let accumulatedData = [];
      let accumulatedText = "";
      let finalGeneratedContent = "";

      await generateProductDescriptionStream(
        initialSku,
        keywords,
        selectedSection.type, // section name, e.g. 'benefit'
        furtherDetails, // furtherDetails
        agentId,
        sessionId,
        (chunk) => {
          // Handle different types of data based on section type
          if (selectedSection.type === "detailed_ingredients") {
            // For ingredients, accumulate structured data
            if (chunk && chunk.ingredient_name) {
              accumulatedData.push(chunk);
              finalGeneratedContent = accumulatedData;
              setExtraSections((prev) =>
                prev.map((section) => {
                  if (section.id === newSectionId) {
                    return {
                      ...section,
                      generatedContent: [...accumulatedData],
                    };
                  }
                  return section;
                })
              );
              updateProductData(initialSku, "detailed_ingredients", [
                ...accumulatedData,
              ]);
            } else if (chunk && chunk.value) {
              // If it's a text chunk, accumulate it
              accumulatedText += chunk.value;
              finalGeneratedContent = accumulatedText;
            }
          } else if (selectedSection.type === "faq") {
            // Handle FAQ data specifically
            if (chunk && chunk.faq) {
              accumulatedData.push(chunk.faq);
              finalGeneratedContent = accumulatedData; // This will be an array of FAQ objects
              setExtraSections((prev) =>
                prev.map((section) => {
                  if (section.id === newSectionId) {
                    return { ...section, generatedContent: accumulatedData };
                  }
                  return section;
                })
              );
            }

            // Initialize finalGeneratedContent if not set
            if (!finalGeneratedContent) {
              finalGeneratedContent = { headline: "", faq: [] };
            }

            // Handle different chunk structures
            let chunkData = null;
            if (chunk && chunk.data && chunk.data.data) {
              chunkData = chunk.data.data;
            } else if (chunk && chunk.value) {
              chunkData = chunk.value;
            } else {
              chunkData = chunk;
            }
            // const currentResponse = {
            //   id: chunkData.id,
            //   question: chunkData.question,
            //   answer: chunkData.answer,
            // };

            updateProductData(
              initialSku,
              selectedSection.type,
              accumulatedData
            );
          } else if (
            selectedSection.type === "benefit" ||
            selectedSection.type === "benefits03" ||
            selectedSection.type === "benefits04"
          ) {
            // Initialize finalGeneratedContent if not set
            if (!finalGeneratedContent) {
              finalGeneratedContent = { headline: "", benefits: [] };
            }

            // Handle different chunk structures
            let chunkData = null;
            if (chunk && chunk.data && chunk.data.data) {
              chunkData = chunk.data.data;
            } else if (chunk && chunk.value) {
              chunkData = chunk.value;
            } else {
              chunkData = chunk;
            }

            // Handle structured benefit data
            if (
              chunkData &&
              typeof chunkData === "object" &&
              (chunkData.headline || chunkData.benefits)
            ) {
              if (chunkData.headline) {
                finalGeneratedContent.headline = chunkData.headline;
              }
              if (chunkData.benefits && Array.isArray(chunkData.benefits)) {
                finalGeneratedContent.benefits = chunkData.benefits;
              }
              if (selectedSection.type === "benefits03") {
                const currentResponse = {
                  title: chunkData.headline,
                  description: chunkData.benefits,
                };

                updateProductData(
                  initialSku,
                  selectedSection.type,
                  currentResponse
                );
              }

              if (selectedSection.type === "benefits04") {
                const currentResponse = {
                  title: chunkData.headline,
                  description: chunkData.benefits,
                };

                updateProductData(
                  initialSku,
                  selectedSection.type,
                  currentResponse
                );
              }

              setExtraSections((prev) =>
                prev.map((section) => {
                  if (section.id === newSectionId) {
                    return {
                      ...section,
                      generatedContent: finalGeneratedContent,
                    };
                  }
                  return section;
                })
              );
            } else if (
              chunkData &&
              typeof chunkData === "object" &&
              chunkData.benefit &&
              chunkData.description
            ) {
              // Handle the API format: {benefit: "title", description: "text"}
              finalGeneratedContent = {
                headline: chunkData.benefit,
                benefits: [
                  {
                    title: chunkData.benefit,
                    description: chunkData.description,
                  },
                ],
              };

              if (selectedSection.type === "benefit") {
                const currentResponse = {
                  title: chunkData.benefit,
                  description: chunkData.description,
                };

                updateProductData(
                  initialSku,
                  selectedSection.type,
                  currentResponse
                );
              }

              setExtraSections((prev) =>
                prev.map((section) => {
                  if (section.id === newSectionId) {
                    return {
                      ...section,
                      generatedContent: finalGeneratedContent,
                    };
                  }
                  return section;
                })
              );
            } else if (chunkData && typeof chunkData === "string") {
              // Handle string content - accumulate it
              accumulatedText += chunkData;

              // Try to parse as JSON if it looks like structured data
              try {
                const parsedData = JSON.parse(accumulatedText);
                if (
                  parsedData &&
                  typeof parsedData === "object" &&
                  (parsedData.headline || parsedData.benefits)
                ) {
                  finalGeneratedContent = {
                    headline: parsedData.headline || "",
                    benefits: parsedData.benefits || [],
                  };

                  setExtraSections((prev) =>
                    prev.map((section) => {
                      if (section.id === newSectionId) {
                        return {
                          ...section,
                          generatedContent: finalGeneratedContent,
                        };
                      }
                      return section;
                    })
                  );
                }
              } catch (e) {
                // Not valid JSON yet, continue accumulating
              }
            }

            // Don't create default content - only save if we have actual generated content
          } else {
            // For other section types, accumulate text
            if (chunk && chunk.value) {
              accumulatedText += chunk.value;
              finalGeneratedContent = accumulatedText;
              setExtraSections((prev) =>
                prev.map((section) =>
                  section.id === newSectionId
                    ? { ...section, generatedContent: accumulatedText }
                    : section
                )
              );
            }
          }
        },
        () => {
          // Only save actual generated content - don't create default placeholders

          setExtraSections((prev) =>
            prev.map((section) => {
              if (section.id === newSectionId) {
                return {
                  ...section,
                  loading: false,
                  generatedContent: finalGeneratedContent,
                };
              }
              return section;
            })
          );

          // Update accumulatedStreamData with the new section - only if we have actual content
          if (
            onSectionUpdate &&
            finalGeneratedContent &&
            (typeof finalGeneratedContent === "string" ||
              (typeof finalGeneratedContent === "object" &&
                finalGeneratedContent !== null &&
                ((finalGeneratedContent.headline &&
                  finalGeneratedContent.benefits &&
                  finalGeneratedContent.benefits.length > 0) ||
                  (selectedSection.type === "faq" &&
                    Array.isArray(finalGeneratedContent)) ||
                  (selectedSection.type === "detailed_ingredients" &&
                    finalGeneratedContent.length > 0))))
          ) {
            // Ensure we're passing the right data structure
            const dataToSend = {
              type: selectedSection.type,
              generatedContent: finalGeneratedContent,
            };
          } else {
          }
        },
        (err) => {
          setExtraSections((prev) =>
            prev.map((section) =>
              section.id === newSectionId
                ? { ...section, loading: false }
                : section
            )
          );
        },
        null,
        languageValue,
        locationValue
      );

      // Update accumulatedStreamData if callback is provided
      if (onSectionUpdate && finalGeneratedContent) {
        onSectionUpdate("add", {
          type: selectedSection.type,
          generatedContent: finalGeneratedContent,
        });
      }
    } catch (error) {
      // Mark section as not loading and show error
      setExtraSections((prev) =>
        prev.map((section) =>
          section.id === newSectionId
            ? { ...section, loading: false, error: error.message }
            : section
        )
      );
    }
  };

  // Get product ID from various sources
  const getProductId = () => {
    // Try multiple sources in order of preference
    if (productId) {
      return productId;
    }
    if (productData?.id) {
      return productData.id;
    }
    if (productData?.shopify_id) {
      return productData.shopify_id;
    }
    if (productData?.amazon_id) {
      return productData.amazon_id;
    }
    // Check if productData has any ID field
    if (productData && typeof productData === 'object') {
      const possibleIdFields = ['id', 'product_id', 'shopify_id', 'amazon_id', '_id'];
      for (const field of possibleIdFields) {
        if (productData[field]) {
          return productData[field];
        }
      }
    }
    console.warn('No product ID found in any source');
    return null;
  };

  // Get section data by ID
  const getSectionData = (sectionId) => {
    // Check in updatedSections
    const section = updatedSections.find(s => s.id === sectionId);
    if (section) {
      return {
        id: section.id,
        title: section.title || sectionId,
        name: sectionId
      };
    }
    
    // Check in extraSections
    const extraSection = extraSections.find(s => s.id === sectionId);
    if (extraSection) {
      return {
        id: extraSection.id,
        title: extraSection.title || extraSection.id,
        name: extraSection.id
      };
    }
    
    // Check in sections
    const currentSection = sections.find(s => s.id === sectionId);
    if (currentSection) {
      return {
        id: currentSection.id,
        title: currentSection.title || currentSection.id,
        name: currentSection.id
      };
    }
    
    // Fallback
    return {
      id: sectionId,
      title: sectionId,
      name: sectionId
    };
  };

  const handleHideSection = (sectionId, sectionTitle) => {
    const sectionData = getSectionData(sectionId);
    setSectionToHide(sectionId);
    setSectionTitleToHide(sectionTitle || sectionData.title);
    setShowHideModal(true);
  };

  const confirmHideSection = async () => {
    const currentProductId = getProductId();
    
    if (!currentProductId) {
      toast.error("Unable to hide section: Product ID not found. Please save the product first.");
      setShowHideModal(false);
      return;
    }
   
    try {
      const sectionData = getSectionData(sectionToHide);
      const platform = productData?.source || "Shopify";
      
      const hiddenSectionData = {
        name: sectionData.name,
        title: sectionData.title,
        is_hidden: true,
        sectionable_type: "Product",
        sectionable_id: currentProductId.toString(),
        description: "Hidden via UI",
        platform: platform,
        note: {}
      };

      await hideSection(hiddenSectionData);
      
      // Update local state to hide the section
      setHiddenSections((prev) => [...prev, sectionToHide]);
      setSectionOrder((prev) => {
        const newOrder = prev.filter(id => id !== sectionToHide);
        if (onSectionUpdate) {
          onSectionUpdate("order", { sectionOrder: newOrder });
        }
        return newOrder;
      });

      // Reload hidden sections from API to refresh the hidden sections list
      hiddenSectionsLoadedRef.current = false;
      await loadHiddenSections();
      
      // Give a small delay to ensure state updates propagate
      await new Promise(resolve => setTimeout(resolve, 200));

      toast.success("Section has been hidden successfully");
      setShowHideModal(false);
      setSectionToHide(null);
      setSectionTitleToHide("");
    } catch (error) {
      console.error("Error hiding section:", error);
      toast.error("Failed to hide section. Please try again.");
      setShowHideModal(false);
    }
  };

  const handleUnhideSection = async (hiddenSectionId, sectionName) => {
    const currentProductId = getProductId();
    
    if (!currentProductId) {
      toast.error("Unable to unhide section: Product ID not found. Please save the product first.");
      return;
    }

    try {
      await unhideSection(hiddenSectionId);
      
      // Remove from hidden sections
      setHiddenSections((prev) => prev.filter(id => id !== sectionName));
      setHiddenSectionsData((prev) => prev.filter(hs => hs.id !== hiddenSectionId));

      // Reload hidden sections from API
      hiddenSectionsLoadedRef.current = false;
      await loadHiddenSections();

      toast.success("Section has been unhidden");
    } catch (error) {
      console.error("Error unhiding section:", error);
      toast.error("Failed to unhide section. Please try again.");
    }
  };

  const handleRemoveSection = (sectionId) => {
    if (sectionId.startsWith("metafield--") || sectionId.startsWith("collections-variant-")) {
      // For metafields, remove from metafields array
      if (metafields && Array.isArray(metafields)) {
        // Extract key from sectionId (format: metafield--{key})
        const key = sectionId.replace("metafield--", "");
        const updatedMetafields = metafields.filter((metafield) => metafield.key !== key);
        if (handleManualEdit) {
          handleManualEdit("metafields", updatedMetafields);
        }
      }
      
      // Remove from section order but DON'T add to hidden sections (removed sections shouldn't show in hidden list)
      setSectionOrder((prev) => {
        const newOrder = prev.filter(id => id !== sectionId);
        if (onSectionUpdate) {
          onSectionUpdate("order", { sectionOrder: newOrder });
        }
        return newOrder;
      });
      return;
    }

    const fixedSectionIds = ["name", "about", "benefits", "description", "ingredients", "howToUse", "dosage", "variants"];
    if (fixedSectionIds.includes(sectionId)) {
      // For fixed sections, just remove from order but DON'T add to hidden sections
      setSectionOrder((prev) => {
        const newOrder = prev.filter(id => id !== sectionId);
        if (onSectionUpdate) {
          onSectionUpdate("order", { sectionOrder: newOrder });
        }
        return newOrder;
      });
      return;
    }

    const sectionToRemove = extraSections.find(
      (section) => section.id === sectionId
    );

    // Remove from extraSections and order, but DON'T add to hidden sections
    setExtraSections((prev) =>
      prev.filter((section) => section.id !== sectionId)
    );
    
    setSectionOrder((prev) => {
      const newOrder = prev.filter(id => id !== sectionId);
      if (onSectionUpdate) {
        onSectionUpdate("order", { sectionOrder: newOrder });
      }
      return newOrder;
    });

    // Update accumulatedStreamData by removing the section
    if (onSectionUpdate && sectionToRemove) {
      // Extract the section type from the section ID (e.g., "benefit-123456" -> "benefit")
      const sectionType = sectionId.split("-")[0];
      onSectionUpdate("remove", {
        type: sectionType,
        generatedContent: sectionToRemove.generatedContent,
      });
    }
  };

  const handleDragEnd = (result) => {
    if (!result.destination || previewMode) return;

    const items = Array.from(sections);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setSections(items);
    
    const newOrder = items.map(section => section.id);
    setSectionOrder(newOrder);
    
    if (onSectionUpdate) {
      onSectionUpdate("order", { sectionOrder: newOrder });
    }
  };

  const [index, setIndex] = useState(0);
  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };
  const [benefits, setBenefits] = useState([]);
  useEffect(() => {
    if (benefits.length === 0 && benifitss) {
      let formattedBenefits = [];

      if (typeof benifitss === "object" && !Array.isArray(benifitss)) {
        formattedBenefits = Object.entries(benifitss).map(
          ([key, value], index) => ({
            id: index + 1,
            text: value,
            icon: "",
          })
        );
      } else if (Array.isArray(benifitss)) {
        formattedBenefits = benifitss.map((text, index) => ({
          id: index + 1,
          text,
          icon: "",
        }));
      }

      setBenefits(formattedBenefits);
    }
  }, [benifitss, benefits.length]);
  const images = [heroImage, ...productImages];
  const previewRef = useRef(null);
  const [mouseY, setMouseY] = useState(window.innerHeight / 2);
  const [insidePreview, setInsidePreview] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [comments, setComments] = useState([]);
  const [showCommentBox, setShowCommentBox] = useState(false);
  const [commentPosition, setCommentPosition] = useState(null);
  const [allHiddenSectionsFromAPI, setAllHiddenSectionsFromAPI] = useState([]);
  const hiddenSectionsLoadedRef = useRef(false);

  // Helper function to map API section name to component section ID
  const mapSectionNameToId = (sectionName) => {
    if (sectionName === "product_title" || sectionName.startsWith("product_title")) return "name";
    if (sectionName === "product_about") return "about";
    if (sectionName === "product_benefits") return "benefits";
    if (sectionName === "product_description") return "description";
    if (sectionName === "product_ingredients") return "ingredients";
    if (sectionName === "product_how_to_use") return "howToUse";
    if (sectionName === "product_dosage") return "dosage";
    // For metafields, handle both old format (metafield-{namespace}-{key}-{index}) and new format (metafield--{key})
    if (sectionName.startsWith("metafield--")) {
      // New format: metafield--{key} - return as-is
      return sectionName;
    }
    if (sectionName.startsWith("metafield-")) {
      // Old format: metafield-{namespace}-{key}-{index} - extract key and convert to new format
      const parts = sectionName.split("-");
      if (parts.length >= 4) {
        const key = parts.slice(2, -1).join("-");
        return `metafield--${key}`;
      }
      return sectionName;
    }
    return sectionName;
  };

  // Helper function to check if a hidden section matches any section in the current product
  const doesHiddenSectionMatchProduct = (hiddenSection, allProductSections) => {
    const sectionName = hiddenSection.name || hiddenSection.section_name;
    const mappedId = mapSectionNameToId(sectionName);
    
    // Check if any product section matches
    return allProductSections.some(section => {
      // Direct ID match
      if (section.id === mappedId || section.id === sectionName) return true;
      
      // For metafields, match by key only (format: metafield--${key})
      if (sectionName.startsWith("metafield--")) {
        const key = sectionName.replace("metafield--", "");
        return section.id === `metafield--${key}` || section.id.includes(key);
      }
      
      // Title match
      if (section.title === hiddenSection.title) return true;
      
      // Check if section ID includes the section name
      if (section.id && section.id.includes(sectionName)) return true;
      
      return false;
    });
  };

  const loadHiddenSections = React.useCallback(async () => {
    // Prevent multiple simultaneous calls, but allow subsequent calls after completion
    if (hiddenSectionsLoadedRef.current) {
      return;
    }

    try {
      hiddenSectionsLoadedRef.current = true;
      // Get user_id from localStorage for authentication
      const userId = localStorage.getItem('user_id');
      if (!userId) {
        console.error('loadHiddenSections: user_id not found in localStorage');
        setAllHiddenSectionsFromAPI([]);
        hiddenSectionsLoadedRef.current = false;
        return;
      }
      
      // Get product ID
      const currentProductId = getProductId();
      if (!currentProductId) {
        console.log('loadHiddenSections: Product ID not available yet');
        setAllHiddenSectionsFromAPI([]);
        hiddenSectionsLoadedRef.current = false;
        return;
      }
      
       const response = await fetchHiddenSections("Product", currentProductId, userId);
      console.log('loadHiddenSections: Full API response:', response);
      
      // Handle the API response structure: { hidden_sections: [...], pagination: {...} }
      let allHiddenSections = [];
      
      if (response && response.hidden_sections && Array.isArray(response.hidden_sections)) {
        allHiddenSections = response.hidden_sections;
      } else if (response && response.data && Array.isArray(response.data)) {
        allHiddenSections = response.data;
      } else if (Array.isArray(response)) {
        allHiddenSections = response;
      }
      
      console.log('loadHiddenSections: All hidden sections (global):', allHiddenSections);
      setAllHiddenSectionsFromAPI(allHiddenSections);
      
      // Reset ref after successful load to allow subsequent reloads
      // Use setTimeout to ensure state update completes first
      setTimeout(() => {
        hiddenSectionsLoadedRef.current = false;
      }, 100);
    } catch (error) {
      console.error('Failed to load hidden sections:', error);
      console.error('Error details:', error.response?.data || error.message);
      // Don't show error toast as it's not critical
      setAllHiddenSectionsFromAPI([]);
      hiddenSectionsLoadedRef.current = false; // Allow retry on error
    }
  }, []);

  // Use refs to track previous values to prevent infinite loops
  const prevSectionIdsRef = React.useRef('');
  const prevHiddenIdsRef = React.useRef('');
  const prevAllHiddenSectionsRef = React.useRef('');

  // Filter and match hidden sections with current product sections
  useEffect(() => {
    // Create a stable string representation of allHiddenSectionsFromAPI to detect changes
    const currentHiddenSectionsString = JSON.stringify(
      allHiddenSectionsFromAPI.map(hs => ({ id: hs.id, name: hs.name, is_hidden: hs.is_hidden }))
    );
    
    if (allHiddenSectionsFromAPI.length === 0) {
      if (hiddenSections.length > 0) {
        setHiddenSectionsData([]);
        setHiddenSections([]);
      }
      prevSectionIdsRef.current = '';
      prevHiddenIdsRef.current = '';
      prevAllHiddenSectionsRef.current = '';
      return;
    }

    // Get current section IDs as a stable string
    const currentSectionIds = [
      ...updatedSections.map(s => s.id),
      ...extraSections.map(s => s.id),
      ...sections.map(s => s.id)
    ].sort().join(',');

    // Check if section IDs have changed OR if hidden sections data has changed
    const sectionIdsChanged = prevSectionIdsRef.current !== currentSectionIds;
    const hiddenSectionsChanged = prevAllHiddenSectionsRef.current !== currentHiddenSectionsString;
    
    if (!sectionIdsChanged && !hiddenSectionsChanged && prevSectionIdsRef.current !== '') {
      return; // No change, skip update
    }
    
    prevSectionIdsRef.current = currentSectionIds;
    prevAllHiddenSectionsRef.current = currentHiddenSectionsString;

    // Get all sections in the current product
    const allProductSections = [...updatedSections, ...extraSections, ...sections];
    
    // Filter: Only keep hidden sections that match sections in the current product AND have is_hidden === true
    const matchingHiddenSections = allHiddenSectionsFromAPI.filter(hiddenSection => {
      // Only show sections where is_hidden is true
      if (hiddenSection.is_hidden !== true) {
        return false;
      }
      return doesHiddenSectionMatchProduct(hiddenSection, allProductSections);
    });
    
    console.log('Filtering hidden sections: Matching for current product:', matchingHiddenSections);
    
    // Calculate new hidden IDs
    const newHiddenIds = matchingHiddenSections.length > 0
      ? matchingHiddenSections.map(hs => {
          const sectionName = hs.name || hs.section_name;
          return mapSectionNameToId(sectionName);
        }).filter(Boolean).sort()
      : [];
    
    const newHiddenIdsString = newHiddenIds.join(',');
    
    // Only update state if the hidden IDs have actually changed
    if (prevHiddenIdsRef.current !== newHiddenIdsString) {
      prevHiddenIdsRef.current = newHiddenIdsString;
      
      if (matchingHiddenSections.length > 0) {
        setHiddenSectionsData(matchingHiddenSections);
        console.log('Setting hidden section IDs:', newHiddenIds);
        setHiddenSections(newHiddenIds);
      } else {
        console.log('No matching hidden sections found for current product');
        setHiddenSectionsData([]);
        setHiddenSections([]);
      }
    }
  }, [allHiddenSectionsFromAPI, updatedSections, extraSections, sections]);

  // Load comments and hidden sections from backend when component mounts or product ID changes
  useEffect(() => {
    const currentProductId = getProductId();
    if (currentProductId) {
      loadComments();
      // Reset the ref to allow reloading when product ID changes
      hiddenSectionsLoadedRef.current = false;
      loadHiddenSections();
    }
  }, [loadHiddenSections, productId]);

  const loadComments = async () => {
    const currentProductId = getProductId();
    if (!currentProductId) return;
    
    try {
      const response = await commentService.getComments('Product', currentProductId);
      const formattedComments = response.data.map(comment => ({
        id: comment.id,
        text: comment.content,
        position: comment.position_y,
        isSaved: true,
        user: comment.user,
        createdAt: comment.formatted_created_at
      }));
      setComments(formattedComments);
    } catch (error) {
      console.error('Failed to load comments:', error);
      // Don't show error toast for comments as it's not critical
    }
  };

  const handleCommentClick = () => {
    setCommentPosition(mouseY);
    setShowCommentBox(true);
  };

  const handleSaveComment = async (text) => {
    if (text.trim() && productId) {
      try {
        const commentData = {
          content: text.trim(),
          position_x: 0, // Default x position
          position_y: commentPosition
        };
        
        const response = await commentService.createComment('Product', productId, commentData);
        const newComment = {
          id: response.data.id,
          text: response.data.content,
          position: response.data.position_y,
          isSaved: true,
          user: response.data.user,
          createdAt: response.data.formatted_created_at
        };
        
        setComments([...comments, newComment]);
        setShowCommentBox(false);
      } catch (error) {
        console.error('Failed to save comment:', error);
        // Fallback to local comment if API fails
        setComments([
          ...comments,
          { text, position: commentPosition, isSaved: false },
        ]);
        setShowCommentBox(false);
      }
    } else if (text.trim()) {
      // Fallback for when productId is not available
      setComments([
        ...comments,
        { text, position: commentPosition, isSaved: false },
      ]);
      setShowCommentBox(false);
    }
  };

  const handleEditComment = async (index, newText) => {
    const comment = comments[index];
    if (!comment.id) {
      // Handle local comments that haven't been saved yet
      const updatedComments = [...comments];
      updatedComments[index].text = newText;
      setComments(updatedComments);
      return;
    }
    
    if (productId) {
      try {
        const commentData = {
          content: newText.trim()
        };
        
        const response = await commentService.updateComment('Product', productId, comment.id, commentData);
        const updatedComments = [...comments];
        updatedComments[index] = {
          ...updatedComments[index],
          text: response.data.content,
          createdAt: response.data.formatted_created_at
        };
        setComments(updatedComments);
      } catch (error) {
        console.error('Failed to update comment:', error);
        // Fallback to local update if API fails
        const updatedComments = [...comments];
        updatedComments[index].text = newText;
        setComments(updatedComments);
      }
    } else {
      // Fallback for when productId is not available
      const updatedComments = [...comments];
      updatedComments[index].text = newText;
      setComments(updatedComments);
    }
  };

  const handleDeleteComment = async (index) => {
    const comment = comments[index];
    if (!comment.id) {
      // Handle local comments that haven't been saved yet
      setComments(comments.filter((_, i) => i !== index));
      return;
    }
    
    if (productId) {
      try {
        await commentService.deleteComment('Product', productId, comment.id);
        setComments(comments.filter((_, i) => i !== index));
      } catch (error) {
        console.error('Failed to delete comment:', error);
        // Fallback to local delete if API fails
        setComments(comments.filter((_, i) => i !== index));
      }
    } else {
      // Fallback for when productId is not available
      setComments(comments.filter((_, i) => i !== index));
    }
  };

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!insidePreview) {
        const previewContainer = previewRef.current; // Use a ref for better accuracy

        if (previewContainer) {
          const { top, height } = previewContainer.getBoundingClientRect();
          let relativeY = e.clientY - top;
          let clampedY = Math.max(0, Math.min(relativeY, height - 20));
          setMouseY(clampedY);
        }
      }
    };

    const handleMouseEnter = () => setInsidePreview(true);
    const handleMouseLeave = () => setInsidePreview(false);

    document.addEventListener("mousemove", handleMouseMove);
    document
      .querySelector(".previewContainer")
      ?.addEventListener("mouseenter", handleMouseEnter);
    document
      .querySelector(".previewContainer")
      ?.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document
        .querySelector(".previewContainer")
        ?.removeEventListener("mouseenter", handleMouseEnter);
      document
        .querySelector(".previewContainer")
        ?.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, [insidePreview]);
  return (
    <>
      {previewMode ? (
        <>
          <div>
            <div
              ref={previewRef}
              className={`${
                previewMode === "mobile"
                  ? styles.mobileContainer
                  : styles.previewContainer
              }`}
            >
              {!showCommentBox && (
                <div
                  className={`${styles.commentIcon} ${
                    isHovered ? styles.heartbeat : ""
                  }`}
                  style={{
                    top: `${mouseY}px`,
                    position: "absolute",
                    backgroundColor: isHovered ? "transparent" : "#00000026",
                    boxShadow: isHovered && "none",
                  }}
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                  onClick={handleCommentClick}
                >
                  {isHovered ? (
                    <svg
                      width="45"
                      height="44"
                      viewBox="0 0 45 44"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M43.18 21.976C43.18 33.5312 33.708 42.952 22.09 42.952C17.576 42.952 13.358 41.5536 9.88 39.1248L1 42.952L4.848 34.12C2.406 30.7344 1 26.5392 1 21.976C1 10.4208 10.472 1 22.09 1C33.708 1 43.18 10.4208 43.18 21.976Z"
                        stroke="#D04734"
                        strokeWidth="2"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <circle cx="15" cy="22" r="2" fill="#D04734" />
                      <circle cx="22" cy="22" r="2" fill="#D04734" />
                      <circle cx="29" cy="22" r="2" fill="#D04734" />
                    </svg>
                  ) : (
                    <LiaCommentDots />
                  )}
                </div>
              )}
              {comments.map((comment, index) => (
                <CommentBox
                  key={index}
                  position={comment.position}
                  commentText={comment.text}
                  isSaved={comment.isSaved}
                  onSave={(text) => handleEditComment(index, text)}
                  onEdit={(newText) => handleEditComment(index, newText)}
                  onDelete={() => handleDeleteComment(index)}
                  user={comment.user}
                />
              ))}

              {showCommentBox && (
                <CommentBox
                  position={commentPosition}
                  onSave={handleSaveComment}
                  onCancel={() => setShowCommentBox(false)}
                  user={currentUser} // Use current user for new comments
                />
              )}

              <div className={styles.contentWrapper}>
                {/* Left Column - Image Gallery */}
                <div className={styles.leftColumn}>
                  <Carousel
                    data-bs-theme="dark"
                    activeIndex={index}
                    onSelect={handleSelect}
                    interval={3000}
                    indicators={false}
                  >
                    {images.map((image, idx) => (
                      <Carousel.Item key={idx}>
                        <img
                          className="d-block w-100"
                          src={image}
                          alt={`Slide ${idx + 1}`}
                        />
                      </Carousel.Item>
                    ))}
                  </Carousel>

                  {/* Thumbnail Strip */}
                  {/* Thumbnail Strip with Scrollable Container */}
                  <div className={styles.thumbnailContainer}>
                    <div className={styles.thumbnailWrapper}>
                      {images.map((image, idx) => (
                        <img
                          key={idx}
                          src={image}
                          alt={`Thumbnail ${idx + 1}`}
                          className={`${styles.thumbnail} ${
                            idx === index ? styles.activeThumbnail : ""
                          }`}
                          onClick={() => setIndex(idx)}
                        />
                      ))}
                    </div>
                  </div>
                </div>

                {/* Right Column - Product Name & About */}
                <div
                  className={styles.rightColumn}
                  styles={{ padding: previewMode != "mobile" ? "30px" : "0" }}
                >
                  {!hiddenSections.includes("name") && productname && (
                    <h2 className={styles.productName}>{productname}</h2>
                  )}
                  {!hiddenSections.includes("about") && productabout && (
                    <p className={styles.aboutText}>{productabout}</p>
                  )}
                </div>
              </div>
              {/* Render sections in the saved order, excluding name and about which are in rightColumn */}
              {sections
                .filter((section) => {
                  // Skip name and about as they're rendered in rightColumn
                  // Also skip hidden sections
                  return section.id !== "name" && 
                         section.id !== "about" && 
                         !hiddenSections.includes(section.id);
                })
                .map((section) => {
                  // Special handling for benefits section
                  if (section.id === "benefits" && !hiddenSections.includes("benefits")) {
                    return (
                      <div key={section.id} className={styles.sectionsContainer}>
                        <div className={styles.benefitsContainer}>
                          <div className={styles.row}>
                            {benefits.map((benefit) => (
                              <div key={benefit.id} className={styles.benefitItem}>
                                <div className={styles.benefitCircle}></div>
                                <span className={styles.benefitText}>
                                  {benefit.text}
                                </span>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    );
                  }
                  
                  // Render all other sections using their Component
                  // Guard clause: Skip rendering if section doesn't have Component
                  if (!section || !section.Component) {
                    return null;
                  }
                  
                  return (
                    <div key={section.id} className={styles.sectionsContainer}>
                      <section.Component
                        previewMode={previewMode}
                        generatedContent={section.generatedContent}
                        loading={section.loading}
                        isNewSection={section.isNewSection || false}
                        language={language}
                        locationFocus={locationFocus}
                        keywords={keywords}
                        agentId={agentId}
                        sessionId={sessionId}
                      />
                    </div>
                  );
                })
                .filter(Boolean)}
            </div>
          </div>
        </>
      ) : (
        <>
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="droppable-sections">
              {(provided) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  className="product-sections-container"
                >
                  {sections?.map((section, index) => {
                    // Guard clause: Skip rendering if section doesn't have Component
                    if (!section || !section.Component) {
                      return null;
                    }
                    
                    const sectionData = getSectionData(section.id);
                    return (
                      <DraggableSection
                        key={section.id}
                        id={section.id}
                        index={index}
                        onRemove={handleRemoveSection}
                        onHide={handleHideSection}
                        previewMode={previewMode}
                        sectionTitle={sectionData.title}
                      >
                        <section.Component
                          previewMode={previewMode}
                          generatedContent={section.generatedContent}
                          loading={section.loading}
                          isNewSection={section.isNewSection || false}
                          language={language}
                          locationFocus={locationFocus}
                          keywords={keywords}
                          agentId={agentId}
                          sessionId={sessionId}
                        />
                      </DraggableSection>
                    );
                  }).filter(Boolean)}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
            </DragDropContext>
          {/* Loader at the bottom for streaming */}
          {isStreaming && (
            <div className="d-flex flex-column align-items-center w-100 mt-3 mb-2">
              <div className="d-flex align-items-center">
                <Loader />
                <span className="ms-2">Loading product details...</span>
              </div>
              {/* Streaming response log removed as per request */}
            </div>
          )}
          <AddSection
            onAddSection={handleAddNewSection}
            previewMode={previewMode}
            initialSku={initialSku}
            keywords={keywords}
            agentId={agentId}
            sessionId={sessionId}
            language={language}
            locationFocus={locationFocus}
            furtherDetails={furtherDetails}
          />
          
          {/* Hidden Sections Section */}
          {hiddenSectionsData.length > 0 && (
            <div className="hidden-sections-container" style={{ marginTop: "2rem", borderTop: "2px solid #e0e0e0" }}>
              <Accordion defaultActiveKey="" style={{ marginTop: "1rem" }}>
                <Accordion.Item eventKey="hidden-sections">
                  <Accordion.Header>
                    <div style={{ 
                      display: "flex", 
                      justifyContent: "space-between", 
                      alignItems: "center", 
                      width: "100%",
                      paddingRight: "1rem"
                    }}>
                      <h3 style={{ fontSize: "18px", fontWeight: 600, color: "#666", margin: 0 }}>
                        Hidden Sections ({hiddenSectionsData.length})
                      </h3>
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div style={{ padding: "1rem 0" }}>
                      {hiddenSectionsData
                        .filter((hiddenSection) => {
                          // Only show hidden sections that exist in the product (filter out removed sections)
                          const allSections = [...updatedSections, ...extraSections, ...sections];
                          return doesHiddenSectionMatchProduct(hiddenSection, allSections);
                        })
                        .map((hiddenSection) => {
                          // Find the actual section data
                          const sectionName = hiddenSection.name || hiddenSection.section_name;
                          const allSections = [...updatedSections, ...extraSections, ...sections];
                          const mappedId = mapSectionNameToId(sectionName);
                          
                          // Use the same matching logic as doesHiddenSectionMatchProduct for consistency
                          const matchingSection = allSections.find(s => {
                            // Direct ID match
                            if (s.id === mappedId || s.id === sectionName) return true;
                            
                            // For metafields, match by key (format: metafield--${key})
                            if (sectionName.startsWith("metafield--")) {
                              const key = sectionName.replace("metafield--", "");
                              if (s.id === `metafield--${key}` || (s.id && s.id.includes(key))) return true;
                            }
                            
                            // Title match
                            if (s.title === hiddenSection.title) return true;
                            
                            // Check if section ID includes the section name (more lenient match)
                            if (s.id && s.id.includes(sectionName)) return true;
                            
                            return false;
                          });

                          // Guard clause: Skip rendering if matchingSection is undefined or doesn't have Component
                          // This is a safety net for edge cases (race conditions, data structure changes, etc.)
                          if (!matchingSection || !matchingSection.Component) {
                            return null;
                          }

                        return (
                          <div 
                            key={hiddenSection.id} 
                            className="product-section"
                            style={{ 
                              marginBottom: "1rem",
                              position: "relative",
                              opacity: 0.7
                            }}
                          >
                            {/* Render the actual section component */}
                            <matchingSection.Component
                              previewMode={previewMode}
                              generatedContent={matchingSection.generatedContent}
                              loading={matchingSection.loading}
                              isNewSection={matchingSection.isNewSection || false}
                              language={language}
                              locationFocus={locationFocus}
                              keywords={keywords}
                              agentId={agentId}
                              sessionId={sessionId}
                              isHidden={true}
                              onUnhide={() => handleUnhideSection(hiddenSection.id, sectionName)}
                              sectionId={matchingSection.id}
                              sectionTitle={hiddenSection.title || sectionName}
                            />
                          </div>
                        );
                      })
                      .filter(Boolean)} {/* Remove null entries from the array */}
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          )}
        </>
      )}
      <ConfirmHideSectionModal
        show={showHideModal}
        onConfirm={confirmHideSection}
        onCancel={() => {
          setShowHideModal(false);
          setSectionToHide(null);
          setSectionTitleToHide("");
        }}
        sectionTitle={sectionTitleToHide}
      />
    </>
  );
};

export default ProductDetailsContainer;

function isDuplicateLayoutSection(sections, layoutType, title) {
  const isDuplicate = sections.some(
    (section) => {
      // Check by layoutType and title
      const sameTypeAndTitle = section.layoutType === layoutType &&
        section.title?.toLowerCase() === title?.toLowerCase();
      
      // Also check by ID pattern for layout sections
      const isLayoutSection = section.id.includes("layout_") && section.id.includes("-loaded-from-db");
      const sameLayoutType = isLayoutSection && section.layoutType === layoutType;
      
      return sameTypeAndTitle || sameLayoutType;
    }
  );
  
  return isDuplicate;
}
